<div class="mt-8 flex justify-content-center align-items-center">
  <div class="flex-column justify-content-center text-center">
    <i class="pi pi-question-circle p-primary" style="font-size: 10.5rem"></i>
    <h1 class="mt-4 p-primary">404: Η σελίδα δεν υπάρχει</h1>
    <h2 class="mt-4 p-gray">
      Φαίνεται πως προσπαθήτε να χρησιμοποιήσετε κάποια λειτουργία <br />
      που είτε δεν υπάρχει, είτε δεν βρίσκεται σε αυτό το σύνδεσμο
    </h2>
  </div>
</div>
